<template>
  <div class="loader-cont">
    <div class="loader-cont__wrapper">
      <div class="loader"></div>
      <div class="loader_text">{{ getTranslations.home_please_wait_page }}</div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters } from 'vuex';

export default {
  name: 'please-wait-init',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/PleaseWaitInit.vue